export const manifest = {
  screens: {
    scr_86hd52: { name: "Home", route: "/" },
  },
}
